const baseUrl = 'https://pictura.acceleratorpracticum.ru/api/v1/';
const baseImageUrl = 'https://pictura.acceleratorpracticum.ru';

export { baseUrl, baseImageUrl };
